import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

import { META_BODY } from './constants';

export const DefendantHeading = styled(Text)(({ theme }) => ({
  fontFamily: "'Lato', sans-serif",
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '24px',
  color: theme.palette.text.primary,
}));

export const ReportSubtitle = styled(Text)(() => ({
  fontFamily: "'Nunito Sans', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16px',
  color: META_BODY,
}));

export const StatValue = styled(Text)(({ theme }) => ({
  fontFamily: "'Lato', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: theme.palette.text.primary,
}));

export const BodyParagraph = styled(Text)(({ theme }) => ({
  fontFamily: `'Nunito Sans', ${theme.typography.fontFamily}`,
  fontSize: 16,
  fontWeight: 400,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  whiteSpace: 'pre-wrap',
}));

export const BulletList = styled(Box)(({ theme }) => ({
  margin: 0,
  marginTop: theme.spacing(0.5),
  paddingLeft: theme.spacing(3),
  '& li': {
    fontFamily: `'Nunito Sans', ${theme.typography.fontFamily}`,
    fontSize: 16,
    lineHeight: '24px',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  '& li:last-of-type': {
    marginBottom: 0,
  },
}));
